// src/App.jsx
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Home from "./pages/Home";
import Legal from "./pages/Legal"; 
import ClientSignIn from "./pages/Client";   
import MiPerfil from "./pages/MiPerfil";

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Inicio */}
        <Route path="/" element={<Home />} />

        <Route path="/Legal" element={<Legal />} />

        {/* Acceso clientes (formulario de RUT) */}
        <Route path="/cliente" element={<ClientSignIn />} />

        {/* Perfil del cliente (usa ?rut=...) */}
        <Route path="/MiPerfil" element={<MiPerfil />} />

        {/* Cualquier ruta desconocida manda al ghome */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}
